import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Tile } from "./primitives";

const LINKS = [
  { href: "https://us.posthog.com", label: "PostHog · pageviews, sessions, geography" },
  { href: "https://dashboard.stripe.com", label: "Stripe · payments, subscriptions, disputes" },
  { href: "https://search.google.com/search-console", label: "Google Search Console · SEO impressions & rank" },
];

export default function ExternalDashboardsPanel() {
  return (
    <Tile title="External dashboards" testid="tile-external">
      <div className="space-y-2 text-xs">
        {LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between text-[#2B5339] hover:underline"
          >
            <span>{l.label}</span>
            <ArrowUpRight size={12} />
          </a>
        ))}
      </div>
      <p className="text-[11px] text-[#5C6B62] mt-4 leading-relaxed">
        This dashboard shows the operational data that lives in your DB. For full
        traffic analytics and payment details, use PostHog and Stripe directly.
      </p>
    </Tile>
  );
}
